import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { ItemAvailabilityDateTimePickerModalPage } from './item-availability-date-time-picker-modal.page';

import { PipesModule } from '../../shared/pipes/pipes.module';

import { SwiperModule } from 'swiper/angular';

@NgModule({
  declarations: [ItemAvailabilityDateTimePickerModalPage],
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild(), PipesModule, SwiperModule],
  exports: [ItemAvailabilityDateTimePickerModalPage],
})
export class ItemAvailabilityDateTimePickerModalPageModule {}
